// Module
var code = "<li class=\"applied-filter\"><strong>{{getLabel()}} </strong><strong><i class=\"icon-cross\" ng-click=\"remove()\"></i></strong></li>\n";
// Exports
module.exports = code;